import { useState } from "react";

import styles from "./LoginMobile.module.css";
import logo from "../../assets/images/logo.png";
import { NavLink, useNavigate } from "react-router-dom";

import { useAuth } from "../../context/auth";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginMobile = () => {
  const MAIN_URL = process.env.REACT_APP_URL

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const { storeTokenInLS } = useAuth();

  // ERROR HANDELING
  const validateForm = () => {
    const newErrors = {};
    if (!user.email.trim()) {
      newErrors.email = "Email or Number is required";
    }
    if (!user.password.trim()) {
      newErrors.password = "Password is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //Handling the Input Values
  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setUser({
      ...user,
      [name]: value,
    });
  };
  //Handling the form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (validateForm()) {
      try {
        const response = await fetch(`${MAIN_URL}/api/auth/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(user),
        });
        if (response.ok) {
          const res_data = await response.json();
          console.log("res from server", res_data);
          storeTokenInLS(res_data.token);
          setUser({ email: "", password: "" });
          setLoading(false);

          toast.success("Sign In Successful!", {
            position: "top-right",
            autoClose: 2000,
          });

          navigate("/home");
        }
      } catch (error) {
        setLoading(false);

        toast.error("An error occurred. Please try again later.");
      }
    } else {
      toast.error("Please fill in all required fields.");
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.login}>
      <section className={styles.login_headContainer}>
            <img className={styles.header_image} src={logo} alt="logo " />
            <div className={styles.header_text}>Musicart</div>
          </section>
        <section className={styles.login_mainContainer}>
        
          <section className={styles.login_heading}>
            <p>Welcome</p>
          </section>
          <section className={styles.container}>
            <div className={styles.container_heading}>
              <p>
                Sign in. <span> Already a customer? </span>
              </p>
            </div>
            <form className={styles.form} onSubmit={handleSubmit}>
              <label className={styles.label} htmlFor="email">
                Enter your email or mobile number
              </label>
              <input
                type="email"
                className={styles.input}
                id="email"
                name="email"
                value={user.email}
                onChange={handleInput}
              />
              <p className={styles.errors} hidden={loading}>
                {errors.email}
              </p>
              <label className={styles.label} htmlFor="password">
                Password
              </label>
              <input
                type="password"
                className={styles.input}
                id="password"
                name="password"
                value={user.password}
                onChange={handleInput}
              />
              <p className={styles.errors} hidden={loading}>
                {errors.password}
              </p>
              <button type="submit" className={styles.login_btn}>
                {loading ? "Loading..." : "Continue"}
              </button>
            </form>
            <p className={styles.condition}>
              By continuing, you agree to Musicart privacy notice and conditions
              of use.
            </p>
          </section>

          <div className={styles.middle}>
            <div className={styles.line}></div>
            <p>New to Musicart?</p>
            <div className={styles.line}></div>
          </div>
          <div className={styles.login_footer}>
            <NavLink className={styles.login_create} to="/signup">
              Create your Musicart account
            </NavLink>
          </div>
        </section>
        <div className={styles.footer_container}>
          <div className={styles.footer}>
            <p> Musicart | All rights reserved</p>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default LoginMobile;
